<template>
  <Layout>

    <div class="rwt-contact-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mb--40">
            <SectionTitle
                text-align="center"
                subtitle="Warranty Form"
                title="Get Your Lifetime Warranty"
            />
          </div>
        </div>
        <div class="row mt--40 row--15">
          <div class="col-12">
            <form class="contact-form-1" novalidate @submit.prevent="$refs.emailDraft.openDraft()">
              <div class="form-group">
                <input
                    type="text"
                    name="amazonOrder"
                    placeholder="Amazon Order ID"
                    required
                    v-model="warranty.amazonOrderId"
                />
              </div>
              <div class="form-group">
                <input
                    type="text"
                    name="fullname"
                    placeholder="Your Name"
                    required
                    v-model="warranty.userName"
                />
              </div>
              <div class="form-group">
                <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    required
                    v-model="warranty.email"
                />
              </div>
              <EmailDraft ref="emailDraft" form-type="warranty" :values="warranty"/>
            </form>
          </div>

        </div>
      </div>
    </div>

  </Layout>
</template>


<script>
import Layout from '@/components/common/Layout'
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'
import EmailDraft from '@/components/elements/contact/EmailDraft.vue'

export default {
  name: 'WarrantyPage',
  components: { Layout, SectionTitle, EmailDraft },
  data() {
    return { warranty: { amazonOrderId: '', userName: '', email: '' } }
  }
}
</script>
